import React from 'react';
import { Modal } from 'react-bootstrap';

export type FileViewerProps = {
  isOpen: boolean;
  file: Blob;
  handleCloseModal: () => void;
};

const FileViewerModal: React.FC<FileViewerProps> = (props: FileViewerProps) => {
  const { isOpen, handleCloseModal, file } = props;
  const blobUrl = URL.createObjectURL(file);
  const handlerClose = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    if (blobUrl) {
      URL.revokeObjectURL(blobUrl);
    }
    handleCloseModal();
  };

  return (
    <Modal
      show={isOpen}
      onClose={(e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => handlerClose(e)}
    >
      <button onClick={handleCloseModal}>Cerrar</button>
      {blobUrl ? <iframe title='Document Viewer' src={blobUrl} width="100%" height="500px" /> : <p>Cargando archivo...</p>}
    </Modal>
  );
};

export default FileViewerModal;
